module.exports = __webpack_public_path__ + "img/heart_hover.624c93ed.svg";